import type { FaireProductEntity } from "../../entity_types/product";

export const p_y67566sr9n: FaireProductEntity = {
  token: "p_y67566sr9n",
  type: "product",
  name: "Gold Dipped Seashell Mini Stud Earrings",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/0ef4b988ed41a2562b247fc355d64d913604740b9343f11fd7305919140abff3.jpeg",
  priceDollars: 7.7,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/daaa2e233715709cb40ea97e80393752586314d20328094efcf2b90b9c964e60.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
